module.exports = __webpack_public_path__ + "img/featureicon1.ae348792.svg";